import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Upload = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Upload' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,9 L12,2 L19,9' />
  </StyledIcon>
);
